import React from "react";
import { Link } from "react-router-dom";
import { features } from "assets";
import Section from "components/layout/Section";

function ViewEntriesView({ defaultRoute, messages, locale }) {
  const { entryOptions } = messages;

  const VIEW_ENTRIES_OPTIONS = [
    {
      name: "health",
      img: features.healthDiary.viewEntriesHealth,
      path: `${defaultRoute}/view_entries_health`,
    },
    {
      name: "medicine",
      img: features.healthDiary.viewEntriesMedicine,
      path: `${defaultRoute}/view_entries_medicine`,
    },
    {
      name: "temperature",
      img: features.healthDiary.viewEntriesTemperature,
      path: `${defaultRoute}/view_entries_temperature`,
    },
  ];

  return (
    <>
      <Section>
        <ViewEntriesOptions>
          {VIEW_ENTRIES_OPTIONS.map((option) => (
            <ViewEntriesOption
              key={option.name}
              {...option}
              messages={entryOptions}
              locale={locale}
            />
          ))}
        </ViewEntriesOptions>
      </Section>
    </>
  );
}

const ViewEntriesOption = (props) => {
  return (
    <div className="column is-6-mobile is-2-desktop">
      <Link to={props.path}>
        <div className="box">
          <div
            style={{ justifyContent: "center", padding: 0 }}
            className="card-content is-flex"
          >
            <figure className="image is-64x64">
              <img
                src={props.img}
                alt={`health_diary_view_entries_option_${props.name}`}
              />
            </figure>
          </div>
          <p
            style={{ marginTop: 12 }}
            className="heading has-text-centered is-uppercase"
          >
            {props.messages[props.name][props.locale]}
          </p>
        </div>
      </Link>
    </div>
  );
};

const ViewEntriesOptions = (props) => {
  return (
    <div className="columns is-2 is-variable is-mobile is-centered is-multiline">
      {props.children}
    </div>
  );
};

export default ViewEntriesView;
